// Un valor que se «asienta» N ms después del último cambio (debounce).
//
// Para los filtros de texto de las bandejas: cada tecla en «Producto» o en el número
// de caso disparaba una consulta al servidor, y con la red lenta la respuesta de
// «PE-0» llegaba después que la de «PE-001» y la pisaba. El token de secuencia de la
// pantalla descarta las obsoletas; esto evita lanzarlas. 300 ms es lo que tarda en
// notarse que se dejó de teclear sin que la lista parezca ignorar lo escrito.
import { useEffect, useState } from 'react';

export function useDiferido<T>(valor: T, ms = 300): T {
  const [diferido, setDiferido] = useState(valor);
  useEffect(() => {
    const temporizador = setTimeout(() => setDiferido(valor), ms);
    return () => clearTimeout(temporizador);
  }, [valor, ms]);
  return diferido;
}
